import { Field } from "formik";
import React from "react";
import { FormGroup, Label } from "reactstrap";

export default function CustomInput({
  label,
  name,
  type = "text",
  values,
  onChange,
  errors,
}) {
  return (
    <FormGroup className="form-group has-float-label">
      <Label>{label}</Label>
      <Field
        className="form-control"
        name={name}
        type={type}
        value={values[name]}
        onChange={onChange}
      />
      {errors[name] && (
        <div className="invalid-feedback d-block">{errors[name]}</div>
      )}
    </FormGroup>
  );
}
